import { render, staticRenderFns } from "./OpenReport_10_2.vue?vue&type=template&id=6431f056&scoped=true&"
import script from "./OpenReport_10_2.vue?vue&type=script&lang=js&"
export * from "./OpenReport_10_2.vue?vue&type=script&lang=js&"
import style0 from "./OpenReport_10_2.vue?vue&type=style&index=0&id=6431f056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6431f056",
  null
  
)

export default component.exports